import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs';
import {
  selectCurrentUserRoles,
  selectLoading,
} from '../../state/current-user/current-user.selectors';
import { RECOVERY_ACCESS_ROLES } from '../shared/tab-access-roles';

export const recoveryTabGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectLoading).pipe(
    filter((loading) => !loading),
    take(1),
    switchMap(() => store.select(selectCurrentUserRoles).pipe(take(1))),
    map((roles) => {
      const allowed = roles.some(
        (role) => role.isActive && RECOVERY_ACCESS_ROLES.has(role.name)
      );
      return allowed ? true : router.parseUrl('/');
    })
  );
};
